/**
 * Full-page navigation away from the SPA (e.g. to a CRM OAuth authorize
 * page). Isolated into its own module purely so it's mockable in tests:
 * `window.location.assign` is a WebIDL `[LegacyUnforgeable]` own property —
 * in this repo's jsdom (26.x) it is non-configurable and non-writable, so
 * neither `jest.spyOn(window.location, 'assign')` nor
 * `Object.defineProperty(window, 'location', ...)` can intercept it (both
 * throw). Routing the call through a plain exported function lets a test
 * `jest.mock` this module instead. The runtime behavior is unchanged — this
 * still just calls `window.location.assign(url)`.
 */
export function navigateExternal(url: string): void {
  window.location.assign(url);
}
